<template>
  <v-card flat>
    <v-card-title class="subheader py-0">
      <v-icon small class="mr-1" color="teal">check_circle</v-icon>
      项目结项
      <v-spacer/>
      <v-btn flat round color="primary" dark
             :disabled="!funcIds.includes('c_proj_concl')"
             @click.native.stop="
             () => {
                  editDbid = null;
                  projectId = project? project.dbid: null;
                  projectClient = project? project.client: null;
                  edit = true;
                }">
        <v-icon>add</v-icon>
        新增结项
      </v-btn>
    </v-card-title>

    <v-divider color="teal"/>

    <v-card-text class="pt-0">
      <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
        class="elevation-0 dense"
        no-data-text="没有数据。"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.index + 1}}</td>
          <td>{{ props.item.organizer || '[未填]' }}</td>
          <td>{{ props.item.conclType ? props.item.conclType.name : '' }}</td>
          <td>{{ props.item.conclLevel ? props.item.conclLevel.name : '' }}</td>
          <td>{{ props.item.userName }}<br/>{{ props.item.examineDate }}</td>
          <td class="justify-center layout px-0">
            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     @click="
                         () => {
                            viewDbid = props.item.dbid; view = true;
                         }">
                <v-icon color="teal">more_horiz</v-icon>
              </v-btn>
              <span>查看</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     :disabled="!funcIds.includes('u_proj_concl')"
                     @click="
                      () => {
                        editDbid = props.item.dbid;
                        projectId = project? project.dbid: null;
                        edit = true;
                      }">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <span>编辑</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     :disabled="!funcIds.includes('d_proj_concl')"
                     @click="
                     () => {
                        deleDbid = props.item.dbid;
                        deleMsg = props.item.organizer;
                        dele = true;
                     }">
                <v-icon color="pink">delete_forever</v-icon>
              </v-btn>
              <span>删除</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>

    </v-card-text>

    <x-view
      v-model="view"
      :dbid="viewDbid"
    />

    <x-edit
      v-model="edit"
      :dbid="editDbid"
      :project-id=projectId
      :project-client=projectClient
      v-on:ok="onEditOk"
    />

    <x-delete
      v-model="dele"
      :message="deleMsg"
      :uri="uri"
      :dbid="deleDbid"
      v-on:ok="onDeleOk"
    />

  </v-card>
</template>
<script>
  import {mapGetters} from 'vuex'

  import XEdit from './Edit'
  import XView from './View'

  import XDelete from '@/components/global/Delete'

  const baseURI = '/api/proj/conclusion';

  export default {
    components: {XEdit, XDelete, XView},

    props: {
      project: Object
    },

    data: () => ({
      uri: baseURI,
      headers: [
        {
          text: '#',
          sortable: false,
          value: 'dbid',
          width: '20'
        },
        {text: '组织单位', value: 'orgnizer', sortable: false},
        {text: '方式', value: 'conclTypeId', sortable: false},
        {text: '结论', value: 'conclLevelId', sortable: false},
        {text: '记录人 / 时间', value: 'timestamp', sortable: false, width: 120},
        {text: '操作', value: 'dbid', sortable: false, align: 'center', width: 60}

      ],

      items: [],

      view: false,
      viewDbid: null,

      edit: false,
      editDbid: null,
      projectId: null,
      projectClient: null,

      dele: false,
      deleDbid: null,
      deleMsg: null,

    }),

    computed: {
      ...mapGetters(['funcIds'])
    },

    watch: {
      project(p) {
        this.axios
          .get(`${baseURI}?projectId=${p.dbid}`)
          .then(rsp => this.items = rsp.data.items)
      }
    },

    methods: {
      onEditOk(item) {
        //console.log("in Income onEditOK");
        if (item) {
          if (!this.editDbid) {
            this.items.unshift(item);
          } else {
            const editIdx = this.items.findIndex((v, i, a) => v.dbid === item.dbid);
            this.items[editIdx] = window.xutil.clone(item);
          }
          this.items = this.items.sort((a, b) => a.rank >= b.rank);
        }
      },
      onDeleOk(item) {
        if (item) {
          const deleIdx = this.items.findIndex((v, i, a) => v.dbid === item.dbid);
          this.items.splice(deleIdx, 1);
        }
      }
    }
  }
</script>
